export default __webpack_public_path__ + "static/char-10-b7ec42aca84d47112516bb9d3d22e28c.gif";